module.exports = {
    // Page Login
    "login.title": "Welcome to Education management system",
    "login.admin_desc": "This section is for system administrators only. For regular users, please use KU All-Login to authenticate.",
    "login.username": "Username",
    "login.password": "Password",
    "LOGIN__FORGOT_PWD": "Forgot password",
    "LOGIN__LOGIN": "Login",
    "LOGIN__PLACEHOLDER_LOGIN": "e.g. b63xxxxxxxx, regxxx",
    "LOGIN__PLACEHOLDER_PWD": "Password",
    "LOGIN__ANNOUNCEMENT": "Announcement",
    "common.ok": "OK",
    "common.cancel": "Cancel",
    "common.back": "Back",
    "common.backUrl": "Home",
    "common.backFirst": "Back",
    "common.academicYear": "Academic Year",
    "common.loadingData": "Please wait",
    "common.pleaes.select": "Please select",
    "common.first.semester": "First semester",
    "common.second.semester": "Second semester",
    "common.summer.semester": "Summer semester",
    "common.year": "Year",
    "COMMON_WELCOME_HOME_PAGE": "Welcome to Enrollment System",
    "COMMON_TOTAL": "Total",
    "COMMON__ALL": "All",
    "COMMON_SUBJECT": "Subject (s)",
    "COMMON_SECTION": "Section",
    "finStd.feeRateNotFound": "Fee information not found Please contact staff",
    "finStd.installmentNotFound": "Payment installment pattern not found Please contact staff",
    "finStd.pageTitle": "Finanace Student",
    "finStd.tabEnrollType": "Enroll Type",
    "finStd.tabFinStd": "Payment",
    "finStd.comment1": "Please select enroll type",
    "finStd.comment2": "The displayed amount is the amount not yet subtracted by discount and loan received.",
    "finStd.comment3": "Please select installment type",
    "finStd.comment3_optional": "select payment type to override",
    "finStd.notTimeToRegistration": "Not open for registration.The registration dates are between ",
    "finStd.probation": "Unable to select the enrollment type because the student has a GPA below 2.00 Please contact the advisor",
    "finStd.financeNotFound": "No payment history information found",
    "finStd.stdLoanInfo": "Students listed for Student Loan can pay later.",
    "finStd.stdLoanInsInfo": "Students listed for Student Loan cannot pay in installments.",
    "finStd.invalidStdTypeWord1": "Student status",
    "finStd.invalidStdTypeWord2": "Unable to perform the transaction Please contact the Office of Education Management",
    "ENROLL__SEARCH_SUBJECT": "Search subject for enroll",
    "enroll.academic.year": "Academic year",
    "enroll.semester": "Semester",
    "ENROLLMENT_DATE": "Enrollment Date",
    "ENROLLMENT_DATE_PRE": "Early-Register date",
    "ENROLLMENT_DATE_PRE_ENG": "Early-Register Date for English 01355102 and 01355103",
    "std.search.student": "Search student",
    "ANNOUNCEMENT_EMPTY": "No announcements",
    "ANNOUNCEMENT_SUBJECT": "Subject Announcements",
    "CLASS_SCHEDULE_TITLE": "Class/Exam Schedule",
    "CLASS_SCHEDULE_CLASS": "Class",
    "CLASS_SCHEDULE_MIDTERM": "Midterm",
    "CLASS_SCHEDULE_FINAL": "Final ",
    "CLASS_SCHEDULE_NOT_FOUND": "Class Schedule Not Found",
    "SUBJECT__QUOTA": "Total Seat",
    "SUBJECT__REGISTERED": "Enrolled",
    "SUBJECT__OPEN_SUBJECT": "Open Subject",
    // "SUBJECT__OPEN_MAJOR_YEAR"               : "สาขาชั้นปีมีสิทธิ์" ,
    "COMMON__CONTACT_TEACHER": "Contact Teacher",
    "COMMON__VIEW_ANNOUNCEMENT": "View Announcement",
    "COMMON__VIEW_DETAIL": "View detail",
    "COMMON__CLASS_SCHEDULE_ROOM": "Room",
    "COMMON__T_TEACHER": "Teacher",
    "COMMON__SEARCH_SUBJECT": "Search Subject",
    "COMMON__SEARCH": "Search",
    "COMMON__CLEAR": "Clear",
    "COMMON__CAMPUS": "Campus",
    "COMMON__SECTION": "Section",
    "COMMON__NO_DATA_TRY_AGAIN": "No data found. Please try again.",
    "COMMON__ENROLLED": "Enrolled",
    "COMMON__CREDIT": "Credit",
    "COMMON__TEACHER": "Teacher",
    "COMMON__ENTER_PHONE_NUMBER": "Please enter contactable phone number.",
    "COMMON__BAHT": "Baht",
    "COMMON__COPY_DOC": "Copy",
    "COMMON__ORIGINAL_DOC": "Original",
    "COMMON__FULL": "Full",
    "COMMON__SUCCESS": "Success",
    "COMMON__APPROVE": "Approve",
    "COMMON__DISAPPROVE": "Disapprove",
    "FNSTD__SV_DL_LEAVE_OF_ABSENCE": "Save and download request form for leave of absence.",
    "FNSTD__PRINT_REQUEST_FORM": "1. Print the request form. (The form appears when Save button clicked.)",
    "FNSTD__PER_INSTALLMENT": "per installment",
    "FNSTD__INSTALLMENTS": "Installments",
    "FNSTD__PAID_AMOUNT": "Paid amount",
    "FNSTD__PENDING_AMOUNT": "Pending amount",
    "FNSTD__DUE_AMOUNT": "Due amount",
    "FNSTD__TOTAL_PENDING_AMOUNT": "Total pending amount",
    "FNSTD__FEE_NOT_PAID": "Fee not paid",
    "FNSTD__CHECK_STATUS": "Check status",
    "FNSTD__PRINT_INVOICE": "Print invoice",
    "FNSTD__PRINT_RECEIPT": "Print receipt",
    "FNSTD__STEP3_SCAN_QR": "STEP 3: Scan QR to make a payment.",
    "FNSTD__CLICK_TO_MAX_QR": "Click to maximize and scan QR Code.",
    "FNSTD__SCAN_TO_PAY": "Scan to pay",
    "FNSTD__CHECK_PAYMENT_STATUS": "Check payment status",
    "FNSTD__INVOICE_DETAILS": "Invoice Details",
    "FNSTD__INVOICE_NO": "Invoice No.",
    "FNSTD__REF_NO_1": "Ref1:",
    "FNSTD__REF_NO_2": "Ref2:",
    "FNSTD__CHK_PAYMENT_STATUS": "Check payment status",
    "FNSTD__CREATE_DATE": "Create Date",
    "FNSTD__UPDATE_DATE": "Update Date",
    "ENROLL__ENROLL": "Enroll",
    "ENROLL__SUBJECTS_ENROLLED": "Subjects Enrolled",
    "ENROLL__SUBJECTS_AWAITING_APPROVAL": "Subjects Awaiting Approval",
    "ENROLL__NO_SUBJECTS_AWAITING_APPROVAL": "No subjects awating approval.",
    "ENROLL__WITHDRAW": "Drop",
    "ENROLL__SELECT_SECTION": "Select Section",
    "ENROLL__AVAILABLE_SECTIONS": "Available Sections",
    "ENROLL__SUBJECT_CODE_NAME": "Subject Code, Subject Name",
    "ENROLL__PLS_SELECT_BOTH_LEC_LAB": "Please select both lec and lab sections.",
    "ENROLL__CONFIRM_ENROLL": "Confirm",
    "ENROLL__CANNOT_ENROLL_FUNDAMENTAL": "Cannot enroll: Fundamental subject not completed.",
    "ENROLL__CANNOT_ENROLL_PRE_CO": "Cannot enroll: Pre-Co not completed.",
    "ENROLL__CHECKING_PRE_CO": "Checking Pre-Co.",
    "ENROLL__ALREADY_ENROLL_GRADE_IS": "Already enrolled. The grade result is ",
    "ENROLL__CANNOT_ENROLL_ALREADY_ENROLLED": "Cannot enroll: Already enrolled in this subject.",
    "ENROLL__NO_SECTIONS_FOUND": "No sections found because either no sections are opened for enrollment or the student major is not matching with any sections.",
    "ENROLL__CHECKING_AVAILABLE_SECTIONS": "Checking available sections",
    "ENROLL__PLS_SELECT_LAB": "Please select lab section.",
    "ENROLL__ENROLLMENT_CONFIRMED": "Enrollment Confirmed.",
    "ENROLL__SUBJECTS": "Subjects",
    "ENROLL__ENROLLMENT_SUCCESSFUL": "Enrollment Successful.",
    "ENROLL__CANNOT_PROCESS": "Cannot process",
    "ENROLL__THERE_R_ENROLLMENTS_IN": "There are enrollments in ",
    "ENROLL__ERM_TYPE_NOT_SELECTED": "Enrollment Type Not Selected.",
    "ENROLL__TRANSACTION_CANT_BE_PROCESS": "Transaction cannot be processed.",
    "ENROLL__SUBJECT_WITHDRAWAL_CF": "Subject drop Confirmed.",
    "ENROLL__GPAX": "GPAX",
    "CHKGRD__CHK_GRD_RESULT": "Check grade result",
    "CHKGRD__CUMULATIVE_CREDIT": "Cumulative credit",
    "CHKGRD__GPA": "GPA",
    "CHKGRD__SUM_GPA": "Cumulative GPA",
    "COMMON__SUM": "Sum",
    "ENROLL__COURSES_NEED_ENROLLED": "Mandatory Subject",
    "ENROLL__NOT_FOUND": "Enrolled Not Found",
    "ENROLL__WARNING_PDF": "If student have already ENROLLED for all subjects Please save the enrolled result (PDF) for use as evidence !!!",
    "COMMON__CONFIRM": "Confirm",
    "ENROLL__CHECK_ENROLL_RESULTS": "Check Enroll Results",
    "ENROLL_WITHDRAW_RECEIVED_GRADE": "Drop With",
    "COMMON__CHECKING_DATA": "Checking data",
    "COMMON__LECTURE": "Lec",
    "COMMON__LAB": "Lab",
    "COMMON__WAITING_APPROVE": "Awaiting Approval",
    "ENROLL__SUBJECTS_WAITING_APPROVE": "Awaiting Approval",
    "FNSTD__SLIDE_TO_ORIGINAL": "Click to  print original document.",
    "FNSTD__SLIDE_TO_COPY": "Click to print copy document.",
    "ENROLL__DISAPPROVAL": "Disapproval",
    "ENROLL__RESULTS": "Enroll Results",
    "ENROLL__PRINT_RESULTS": "Print Enroll Results",
    "ENROLL__STD_LOANS": "Print Student Loans",
    "FNSTD__DISCOUNT": "Discount",
    "FNSTD__SCHOLARSHIPS": "Scholarships",
    "FNSTD__LOAN": "Loan",
    "FNSTD__TOTAL_PAID": "Total paid",
    "FNSTD__TOTAL_OUTSTANDING": "Total outstanding",
    "ENROLL__ELIGIBLE_MAJOR": "Eligible Major",
    "ENROLL__INELIGIBLE_MAJOR": "Ineligible Major ",
    "ENROLL__ENROLL_": "Enroll",
    "FNSTD__PAYMENT_DETAIL": "Payment details",
    "FNSTD__PAYMENT_STATUS": "Payment status",
    "MENU__ENROLLED_HISTORY": "Enroll History",
    "MENU__CLASS_EXAM": "Class / Exam Schedule",
    "MENU__OPEN_SUBJECT": "Open Subject",
    "MENU__ENROLL_TYPE_FIN": "Enroll Type / Finance",
    "MENU_ADD_DROP": "Enroll Add/Drop",
    "MENU__ENROLL_RESULT": "Enroll Results",
    "MENU__GRADE": "Check Grades",
    "MENU__DASHBOARD": "Dashboard",
    "FNSTD__RECEIPT_NO": "Receipt No.",
    "MENU__STUDENT_NEWS": "Student News",
    "FNSTD__PAYMENT_METHODS": "Payment methods",
    "FNSTD__PATMENT_DATE": "Payment date",
    "FNSTD__RECEIPT_ORI": "Receipt (original)",
    "FNSTD__ORI_PUBLISHER": "Original publisher",
    "FNSTD__ORI_PUBLISH_DATE": "Original publication date",
    "FNSTD__PAYEE": "Payee",
    "COMMON_MSG_1": "Please enter a student code or name",
    "COMMON_MSG_2": "to search for the student information.",
    "COMMON__MSG_SEARCH_1": "To find information",
    "COMMON__MSG_SEARCH_2": "please search by code or name.",
    "COMMON__TEACHER_COURSE_NOT_FOUND": "The teacher's courses could not be found.",
    "COMMON__CREATE_BY": "Create By",
    "COMMON__ADD": "Add",
    "COMMON__CREATE_DATE": "Create Date",
    "COMMON__DATA_NOT_FOUND": "Data not found.",
    "COMMON__PLZ_TRY_AGAIN": "Please try again",
    "COMMON_MSG_SUB_1": "Please enter a subject code or name",
    "COMMON_MSG_SUB_2": "to search for the subject details.",
    "COMMON_SEARCHING": "Searching...",
    "COMMON__ENROLLMENT_SYSTEM_KU": "Education management system, Kasetsart University",
    "FNSTD__PAID": "Paid",
    "FNSTD__NOT_YET_PAID": "Unpaid",
    "MSG_ENROLLMENT_TYPE_NOT_FOUND": "Enrollment Type Not Found.",
    "MSG_PLEASE_SELECT_ENROLLMENT_TYPE": "Please Select Enrollment Type.",
    "BTN_SELECT_ENROLLMENT_TYPE": "Select Enrollment Type",
    "MSG_FEE_FOUND": "Pending Fee Found.",
    "MSG_CHECK_FIN": "Please Check The Financial Information or Fines from the Organization at the Dashboard menu.",
    "BTN_UNPAID": "Please Check The Unpaid Fee.",
    "MSG_NOT_TIME_TO_ENROLL": "Outside Enrollment Period.",
    "MSG_CAN_ENROLL": "Eligible enrollment dates and times are between",
    "BTN_CANCEL_PAYMENT": "Cancel Payment",
    "FNSTD__PARTIAL_PAYMENT": "Partial payment",
    "FNSTD__WITHDRAWABLE": "Withdrawable",
    "FNSTD__POSTPONED": "Postponed",
    "FNSTD__ON_INSTALLMENT": "On Installment",
    "MSG_CONFIRM_SELECT_PAYMENT": "Do you want to confirm the selected payment?",
    "MSG_ENROLLMENT_SUCCESSFUL": "Enrollment Successful",
    "MSG_INSTALLMENT_AMOUNT": "Installment amount",
    "MSG_TYPE": "Type",
    "COMMON__ANNOUNCED_ON": "Announced on",
    "FNSTD__FULL_EDU_FEE_REG": "Full Education Fee (Regular Semester)",
    "COMMON__LATEST_ON": "Latest on",
    "COMMON__BY": "By",
    "FNSTD__PAYMENT_SUCCESSFUL": "Payment successful",
    "MSG__STD_CONTACT_LEAVE": "Please enter a contactable phone no.",
    "MSG__STD_CONTACT_LEAVE_DETAILS_1": "1. Print out a Leave of Absence Request Form. (The form will appear when the save button is clicked.)",
    "MSG__STD_CONTACT_LEAVE_DETAILS_2": "2. Hand in the request form to the advisor, Head of Department, Dean of Affiliation respectively for approval.",
    "MSG__STD_CONTACT_LEAVE_DETAILS_3": "3. Send the approved form to the Office of Education Administration.",
    "MSG__STD_CONTACT_LEAVE_DETAILS_4": "4. The Office of Education Administration will proceed further.",
    "MSG__STD_ATTENTION_HEADER": "Attention  !!!",
    "BTN__STD_SAVE_AND_DOWNLOAD": "Save and download Form.",
    "MSG__STD_ATTENTION_DETAILS_1": "In case the enrollment type or payment type is changed, a new QR code must be used in payment. The system automatically generates a new QR code after the",
    "MSG__STD_ATTENTION_DETAILS_2": "button in enrollment process is hit. If students pay the fee with old QR code, the system will not see the matched payment transaction and hence the status is unpaid.",
    "MSG__STD_ATTENTION_DETAILS_3": "Click the",
    "MSG__STD_ATTENTION_DETAILS_4": "button below to proceed.",
    "COMMON__AND": "and",
    "COMMON__OR": "or",
    "COMMON__AND_OR": "and/or",
    "INFO_DOC_FOR_WITHDRAWAL": "Documents for withdrawal",
    "INFO_DOC_FOR_WITHDRAWAL_DETAIL_1": "1. KU2 receipt can be printed out as",
    "INFO_DOC_FOR_WITHDRAWAL_DETAIL_2": "only 1 time. Later will be",
    "INFO_DOC_FOR_WITHDRAWAL_DETAIL_3": "Copies",
    "INFO_DOC_FOR_WITHDRAWAL_DETAIL_4": "If students cannot print the original, please contact Office of the Registrar.",
    "INFO_DOC_FOR_WITHDRAWAL_DETAIL_5": "2. Students whose parent can claim the children education allowance can print out the request form at ",
    "ENROLL__COURSE_HV_TO_ENR_WITH": "This course have to enroll with",
    "ENROLL__WOULD_LIKE_TO_ENROLL": "Would like to enroll",
    "ENROLL__PLS_SEL_C_TOGETHER": "Please select course to enroll together",
    "ENROLL__PLS_SEL_C": "Please select course",
    "ENROLL__AT": "at",
    "MSG__ENROLL_TYPE_1": "Outside eligible enrollment type selection dates.",
    "MSG__ENROLL_TYPE_2": "The selection dates are between",
    "MSG__ENROLL_TYPE_3": "Education Calendar for Enrollment Type",
    "MSG__ENROLL_TYPE_4": "Selection Activity Not Configured.",
    "MSG__ENROLL_TYPE_5": "Please contact the Office of Educational Administration.",
    "CHKGRD__PRINT_GRD_RESULT": "Print grade result",
    "ENROLL__PLS_SEL_CREDIT_2_ER": "Please select the amount of credit to enroll.",
    "ENROLL__FN_X_DT_HAS_DUP": "Final exam date and time has duplicate with ",
    "ENROLL__MD_X_DT_HAS_DUP": "Midterm exam date and time has duplicate with ",
    "ENROLL__LRN_X_DT_HAS_DUP": "Studying date/time has duplicate with ",
    "ENROLL__ENR_NOT_IN_PERIOD": "Not in the enrollment period.",
    "ENROLL__AT_PERIOD_DROP_ONLY": "At the period of subject withdrawal only.",
    "ENROLL__CREDIT_AMOUNT_HAS_OVER": "Credit has over specified amount.",
    "ENROLL__BECAUSE_SEL_MAINTAIN_TYPE": "Because select enrollment with maintain status type. ",
    "ENROLL__SECTION_FULL": "Section full.",
    "ENROLL__ENROLLMENT_TYPE": "Change Enrollment type",
    "ENROLL__CREDIT_AMOUNT": "Change Credit amount",
    "COMMON__PROCESSING": "Processing...",
    "ENROLL__LATE_ENROLL": "Late enroll",
    "ENROLL__DOESNT_MEET_CONDITION": "Does not meet the conditions to enroll.",
    "ENROLL__OP_ER_IN_PERIOD_ONLY": "Open for enroll in the period of late enrollment only.",
    "COMMON__ALREADY": "already.",
    "ENROLL__CANT_PRCSS_ER_NT_FOUND": "Cannot be process, enroll list not found.",
    "ENROLL__PLS_SELECT_LEC": "Please select lecture section.",
    "ENROLL__THERE_R_ER_IN_GRP_OF": "There are enrollment in the same group of special subject",
    "ENROLL__EARLY_REGISTER": "Early-Register",
    "ENROLL__SEARCH_SUBJECT_PRE": "Search subject for early-register",
    "COMMON__SUCCESSFUL": "Successful",
    "ERRESULT__SEARCH_STUDENT": "Search student",
    "ERRESULT__SEARCH_FACULTY": "Search faculty",
    "ERRESULT__SEARCH_MAJOR": "Search major",
    "ERRESULT__SPECIFY_STD_NAME_CODE": "Please specify the student name/code.",
    "ERRESULT__SPECIFY_FACULTY": "Please specify the faculty name.",
    "ERRESULT__SPECIFY_MAJOR": "Please specify the major name.",
    "ANNOUNCEMENT__NO_SUBJECT": "Announcement from teacher",
    "COMMON__SUCCESSFUL_STATUS": "Successful ",
    "COMMON__TOTAL": "Total",
    "BTN__SAVE": "Save",
    "MENU__COURSES_ADD_DROP_ANNOUNCE": "Courses (Add-Drop/Announcement)",
    "MENU__STUDENTS_UNLOCK_CONSIDER": "Students (Unlock Consider)",
    "MENU__STUDENTS_ENROLL_RESULT": "Students (Check Enroll Results)",
    "COMMON__REMARK": "Remark",
    "SUBJECT__QUOTA__TOTAL": "Total Seat",
    "SUBJECT__REGISTERED__TOTAL": "Total Enrolled",
    "PERSONS": "person(s)",
    "ENROLL__CANT_DROP_COUSE_CREDIT": "Unable to DROP courses less than the required credits",
    "ENROLL__CANNOT_BE_PROCESS": "Cannot process",
    "ENROLL__WITHDRAW_W": "Drop W",
    "LOGIN__CONTACT_US": "Contact us",
    "COMMON__NAME_SURNAME": "Name-Surname",
    "PROFILE__PERSONAL_INFO": "Personal information",
    "PROFILE__FATHER_INFO": "Father information",
    "PROFILE__MOTHER_INFO": "Mother information",
    "PROFILE__EDU_INFO": "Educational information",
    "PROFILE__STATUS_HISTORY": "Student status change history",
    "PROFILE__TRANSFER _HISTORY": "Student transfer history",
    "PROFILE__REGISTERED_ADDRESS": "Registered Address",
    "PROFILE__PRESENT_ADDRESS": "Present address",
    "PROFILE__ID_NO": "Identity Card No.",
    "PROFILE__NAME_SURNAME_TH": "Name-Surname (TH)",
    "PROFILE__NAME_SURNAME_EN": "Name-Surname (EN)",
    "PROFILE__DATE_OF_BIRTH": "Date of birth",
    "PROFILE__NATIONALITY": "Nationality",
    "PROFILE__RELIGION": "Religion",
    "PROFILE__MOBILE": "Mobile",
    "PROFILE__TEL": "Tel.",
    "PROFILE__BARCODE_LIB": "Library Barcode",
    "PROFILE__PHYSICAL_CONDITION": "Physical condition",
    "PROFILE__GENERAL_INFO": "General information",
    "PROFILE__ADDRESS": "Address",
    "PROFILE__GRADE_RESULT": "Grade result",
    "PROFILE__EDUCATION_LEVEL": "Education level",
    "PROFILE__STD_STATUS": "Student status",
    "PROFILE__STD_TYPE": "Student type",
    "PROFILE__DEGREE_NAME": "Degree name",
    "PROFILE__COURSE": "Course",
    "PROFILE__FACULTY": "Faculty",
    "PROFILE__DEPARTMENT": "Department",
    "PROFILE__MAJOR": "Major",
    "PROFILE__ADMISSION_DATE": "Admission date",
    "PROFILE__ADMISSION_TYPE": "Admission type",
    "PROFILE__GET_IN_PROJECT": "Get-in project",
    "PROFILE__WELFARE_LIST": "Welfare list",
    "PROFILE__PROGRAM": "Program",
    "PROFILE__MAJOR_SUBJECT": "Major subject",
    "PROFILE__ATTENDED_DATE": "Attended date",
    "PROFILE__EDU_STATUS_OLD": "Educational status (Old)",
    "PROFILE__EFFECTIVE_DATE": "Effective date",
    "PROFILE__RECORDED_BY": "Recorded by",
    "PROFILE__CAUSE": "Cause",
    "PROFILE__REASON_DATE": "Reason date",
    "PROFILE__DOCUMENT_S": "Document(s)",
    "PROFILE__EDU_STATUS_PRESENT": "(Present)",
    "PROFILE__EDU_STATUS": "Educational status ",
    "COMMON__ADVISOR": "Advisor",
    "PROFILE__APPROVED_DATE": "Approved date",
    "PROFILE__TRANSACTION_DATE": "Transaction date",
    "PROFILE__COURSE_NEW": "Course (New)",
    "PROFILE__COURSE_OLD": "Course (Old)",
    "PROFILE__ADDRESS_NO": "Address No.",
    "PROFILE__VILLAGE_NO": "Village No.",
    "PROFILE__BUILDING_NO": "ฺฺBuilding",
    "PROFILE__FLOOR": "Floor",
    "PROFILE__LANE": "Alley/Lane",
    "PROFILE__ROAD": "Road",
    "PROFILE__SUB_DISTRICT": "Sub-district/Sub-area",
    "PROFILE__DISTRICT": "District/Area",
    "PROFILE__PROVINCE": "Province",
    "PROFILE__COUNTRY": "Country",
    "PROFILE__POSTAL_CODE": "Postal Code",
    "PROFILE__HOME_PHONE": "Home phone",
    "ENROLL__UNLOCKED": "Unlocked",
    "COMMENT__ENROLLED": "The registration type cannot be changed",
    "FIN__QR_EXPIRED1": "QR has expired, can pay again on the ",
    "FIN__QR_EXPIRED2": " of next month.",
    "FIN__QR_INFO": "This QR Code will expires on ",
    "ENROLL__CHANGE_SECTION": "Change Section",
    "ENROLL__CHANGE_SECTION_INPROCESS1": "In Progress ",
    "ENROLL__CHANGE_SECTION_INPROCESS2": "Change Section",
    "ENROLL__REG_NOT_ANNOUNCED": "Registration not announced",
    "ENROLL__SEC_CLOSED": "Section closed",
    "PROFILE__GENDER": "Gender",
    "PROFILE__PASSPORT_NO": "Passport No.",
    "ENROLL__SUBJECT_MAPPING": "Can study instead of subjects",
    "SUBJECT__OPEN": "COURSE OPENED",
    "PROFILE__RESTORATION_DATE": "Restoration Date",
    "PROFILE__RESTORATION_UPDATE_BY": "Restoration By",
    "PROFILE__RESTORATION_REMARK": "Restoration Remark",
    "PROFILE__UPDATE_DT": "Update Date",
    "ENROLL__CANNOT_ENROLL_MAX": "The maximum number of students in specified Major-Year has been reached.",
    "ENROLL__CANNOT_ENROLL_MAX_HEADER": "Cannot enroll into this section: ",
    "FIN__STATUS_PAYMENT_NOT_S": "Right after your bank transfer, if the payment status has not been updated, please recheck here once again next working day.",
    "FIN__STATUS_PAYMENT_IS_S": "Your payment status will not be automatically updated right after your bank transfer, please do revisit this page again next working day.",
    "FIN__STATUS_PAYMENT": "Payment Status",
    "QR_CODE_PAYMENT_EXPIRED": "Expired",
    "QR_CODE_PAYMENT_SYSTEM_NOT_CONNECT": "Unable to connect to the QR Code. Please try again later.",
    "FNSTD__PRINT_CREDIT_NOTE": "Print Credit Note",
    "ENROLL__SECTION_TYPE": "Section type : ",
    "ANNOC__GENERAL_INFO": "General",
    "ENROLL_STATUS_ITEMS": "Records",
    "MSG__STD_STATUS_DISCOUNT": "การลงทะเบียนขอรับสิทธิ์ลดหย่อน ภาคปลาย ปีการศึกษา  2564",
    "MSG__STD_STATUS_DISCOUNT_2": "ภาคปลาย ปีการศึกษา 2564",
    "MSG__STD_STATUS_DISCOUNT_CF": "คลิกที่นี่เพื่อไปหน้าหลักส่วนลด",
    "MSG__STD_STATUS_DISCOUNT_CC": "ยกเลิก",
    "MSG__STD_STATUS_DISCOUNT_LINK": "คลิกที่นี่เพื่อไปหน้าหลักส่วนลด",
    "MENU__STUDENT_DISCOUNTS": "Student Scholarship/Discounts",
    "FINSTD__DISCOUNT_NOT_FOUND": "Student Scholarship/Discount Not Found.",
    "FINSTD__PLEASE_SELECT_DISCOUNT": "Please Select Scholarship/Discount",
    "FINSTD__CONFIRM_SELECT_DISCOUNT": "Confirm Select Scholarship/Discount",
    "FINSTD__SELECT_DISCOUNT_DATE_START": "เลือกรับทุน/ส่วนลดได้ตั้งแต่วันที่ ",
    "FINSTD__SELECT_DISCOUNT_DATE_END": "ถึงวันที่ ",
    "FINSTD__MOBILE_DATE_SELECT_DISCOUNT": "กำหนดรับ ",
    "FINSTD__SELECT_DISCOUNT_SUCCESS": "Select Scholarship/Discount Success",
    "FINSTD__SELECT_DISCOUNT_UNSUCCESS": "Select Scholarship/Discount Unsuccess",
    "FINSTD__CONFIRM_CANCEL_SELECT_DISCOUNT": "Cancel Scholarship/Discount",
    "FINSTD__CANCEL_DISCOUNT_SUCCESS": "Cancel Scholarship/Discount Success",
    "FINSTD__CANCEL_DISCOUNT_UNSUCCESS": "Cancel Scholarship/Discount Unsuccess",

    "TRN_STUDYSOURCE_LABEL": "Transfer from",
    "TRN_STUDYSOURCE_IN": "Kasetsath U.",
    "TRN_STUDYSOURCE_OUT": "Other U.",
    "TRN_TARGET_STUDENT": "Select previous enrollment",
    "TRN_SELECT_UNIVERSITY": "Select source university",

    "GRD_VALUE_ALL": "All",

    "COMMON_YOU_CAN_LOG_IN_WITH" : "Staff Only",
    "COMMON_MORE_DETAIL": "If you have any questions or would like to inquire for more information, please contact us."
}
